/**
 * Spinner component - Unified loading indicator
 *
 * A customizable circular loading spinner that uses CSS animations.
 * Inherits color from parent via currentColor for maximum flexibility.
 *
 * Features:
 * - Three size variants: sm, md, lg
 * - Color inherited from parent text color
 * - Smooth SVG animations (rotate + dash)
 * - Accessible with ARIA attributes
 */

interface SpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-12 h-12',
  lg: 'w-16 h-16',
};

export default function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  const sizeClass = sizeMap[size];

  return (
    <svg
      className={`${sizeClass} ${className} animate-spinner-rotate`}
      viewBox="0 0 50 50"
      role="status"
      aria-label="Chargement"
      style={{ transformOrigin: 'center' }}
    >
      <circle
        className="animate-spinner-dash"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="1, 200"
        strokeDashoffset="0"
      />
    </svg>
  );
}
